import { Grid } from 'react-bootstrap';
import styled from 'styled-components';

const StyledGrid = styled(Grid) `
    font-size: 16px;
    line-height: 32px;
    color: ${props => props.theme.colors.black};
`;

export default StyledGrid;



// WEBPACK FOOTER //
// ./src/components/atoms/form/FormViewGrid.js